import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FieldValue } from '../../../../../components/map/map.interfaces';

@Injectable({ providedIn: 'root' })
export class MultipleSearchMapFormFieldService {
  private valueChanged$: Subject<FieldValue> = new Subject<FieldValue>();
  private attributeChanged$: Subject<void> = new Subject<void>();

  public get fieldValueChanged(): Observable<FieldValue> {
    return this.valueChanged$.asObservable();
  }

  public get attributeChanged(): Observable<void> {
    return this.attributeChanged$.asObservable();
  }

  public setFieldValue(value: FieldValue): void {
    return this.valueChanged$.next(value);
  }

  public notifyAttributeChanged(): void {
    return this.attributeChanged$.next();
  }
}
